import { inject, Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';
import { SNACK_BAR_DURATION } from '@core/const';
import { SimpleSnackbarComponent } from '@shared/components';
import { SnackbarActionType } from '@interfaces';

@Injectable({
  providedIn: 'root',
})
export class SnackbarService {
  private readonly snackBar = inject(MatSnackBar);

  showSimpleSnackBar(
    message: string,
    action: SnackbarActionType = SnackbarActionType.Done,
    duration: number = SNACK_BAR_DURATION,
    verticalPosition: MatSnackBarVerticalPosition = 'bottom',
    horizontalPosition: MatSnackBarHorizontalPosition = 'center',
  ) {
    return this.snackBar.openFromComponent(SimpleSnackbarComponent, {
      duration,
      verticalPosition,
      horizontalPosition,
      panelClass: 'snackbar',
      data: {
        action,
        message,
      },
    });
  }
}
